// extracted by mini-css-extract-plugin
export default {"cardSpacing":"teamOverview_cardSpacing__sg2PJ"};